module.exports = __webpack_public_path__ + "img/versa_side.e12d99da.png";